/**
 * Tokens de marca Xperience Group
 * Fuente única de verdad para colores en JS (los de Tailwind se duplican en config)
 */
export const BRAND = {
  gold: '#FBCB22',
  goldDark: '#D4A817',
  black: '#000000',
  white: '#FFFFFF',
};

export const SUBMARCAS = {
  group: {
    id: 'group',
    name: 'Xperience Group',
    tag: 'Creative Company',
    accent: '#FBCB22',
  },
  realEstate: {
    id: 'realEstate',
    name: 'Xperience Real Estate',
    tag: 'Creative Company',
    accent: '#A3A3A3',
  },
  media: {
    id: 'media',
    name: 'Xperience Media',
    tag: 'Creative Company',
    accent: '#B60404',
  },
};
